import React from 'react';
import { TextField, Typography, Box, Grid, Button, Snackbar, Alert } from '@mui/material';
import { useAntropometriaForm } from '../hooks/useAntropometriaForm';

const MedidasAntropometricas = ({ idPaciente }) => {
  const {
    datos,
    errores,
    notificacion,
    computed,
    handleChange,
    closeNotification,
    guardarDatos,
  } = useAntropometriaForm({ idPaciente });

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: '100vh', p: 2, backgroundColor: 'white' }}>
      <Box sx={{ maxWidth: 1500, width: '100%', p: 2 }}>
        <Typography variant="h4" sx={{ textAlign: 'center', color: 'black' }}>
          ANTROPOMETRÍA
        </Typography>

        <Box sx={{ marginTop: 4, maxWidth: 1000 }}>
          <TextField label="ID del Paciente" variant="outlined" sx={{ width: '25%', marginBottom: 4 }} value={idPaciente} disabled />

          <Grid container spacing={2}>
            {[
              { label: 'Talla (cm)', name: 'talla' },
              { label: 'Peso (kg)', name: 'peso' },
            ].map(({ label, name }) => (
              <Grid item xs={4} key={name}>
                <TextField
                  fullWidth
                  label={label}
                  variant="outlined"
                  name={name}
                  value={datos[name]}
                  onChange={handleChange}
                  error={!!errores[name]}
                  helperText={errores[name]}
                  inputProps={{ inputMode: 'decimal', pattern: '[0-9.,]*' }}
                />
              </Grid>
            ))}
            <Grid item xs={4}>
              <TextField fullWidth label="IMC (kg/m²)" variant="outlined" value={computed.imc} disabled />
            </Grid>
          </Grid>

          <Typography variant="h6" sx={{ marginTop: 4 }}>
            PERÍMETRO ABDOMINAL
          </Typography>
          <Grid container spacing={2}>
            {['perimetroAbdominal1', 'perimetroAbdominal2', 'perimetroAbdominal3'].map((name, index) => (
              <Grid item xs={3} key={name}>
                <TextField
                  fullWidth
                  label={`Medida ${index + 1} (cm)`}
                  variant="outlined"
                  name={name}
                  value={datos[name]}
                  onChange={handleChange}
                />
              </Grid>
            ))}
            <Grid item xs={3}>
              <TextField fullWidth label="Media Perímetro (cm)" variant="outlined" value={computed.mediaPerimetroAbdominal} disabled />
            </Grid>
          </Grid>

          <Typography variant="h6" sx={{ marginTop: 4 }}>
            IMPEDANCIA
          </Typography>
          <Grid container spacing={2}>
            {[
              { label: 'Grasa (%)', name: 'grasa' },
              { label: 'Músculo', name: 'musculo' },
              { label: 'Nivel de grasa visceral', name: 'nivelGrasa' },
            ].map(({ label, name }) => (
              <Grid item xs={4} key={name}>
                <TextField
                  fullWidth
                  label={label}
                  variant="outlined"
                  name={name}
                  value={datos[name]}
                  onChange={handleChange}
                  error={!!errores[name]}
                  helperText={errores[name]}
                />
              </Grid>
            ))}
          </Grid>

          <Typography variant="h6" sx={{ marginTop: 4 }}>
            MASA MUSCULAR APENDICULAR (ASM)
          </Typography>
          <Grid container spacing={2}>
            {['bd', 'bi', 'pd', 'pi'].map((name, index) => (
              <Grid item xs={3} key={name}>
                <TextField
                  fullWidth
                  label={`${['BD', 'BI', 'PD', 'PI'][index]} (kg)`}
                  variant="outlined"
                  name={name}
                  value={datos[name]}
                  onChange={handleChange}
                  error={!!errores[name]}
                  helperText={errores[name]}
                />
              </Grid>
            ))}

            <Grid item xs={12}>
              <TextField fullWidth label="Peso Brazos y Piernas (kg)" variant="outlined" value={computed.pesoBrazosPiernas} disabled />
            </Grid>
          </Grid>

          <Typography variant="h6" sx={{ marginTop: 4 }}>
            SMI (Skeletal Muscle Index)
          </Typography>
          <Grid item xs={12}>
            <TextField fullWidth label="SMI" variant="outlined" value={computed.smi} disabled />
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
            <Button variant="contained" color="primary" onClick={guardarDatos}>
              Guardar Datos
            </Button>
          </Box>

          <Snackbar open={notificacion.open} autoHideDuration={3000} onClose={closeNotification}>
            <Alert severity={notificacion.tipo} onClose={closeNotification}>
              {notificacion.mensaje}
            </Alert>
          </Snackbar>
        </Box>
      </Box>
    </Box>
  );
};

export default MedidasAntropometricas;
